export default __webpack_public_path__ + "static/media/19-1_clouddownload.8d1f1225.svg";